export class VenderMiniEntity {
  id?: number
  name?: string | null
  imageUrl?: string | null
}
